import { Fieldset } from "@trussworks/react-uswds";
import { Dispatch, SetStateAction, useState } from "react";
import { 
  SearchFilters,
 } from "../../../types/v1_schemas";
 import { useTranslation } from "react-i18next";
 import {
  optionWithId,
  getLookupOptions
} from "../../../utils/lookup";
import { AnalyticsAction, logEvent } from "../../../utils/analytics";
import { toggleItemInFilterList } from "../../../utils/filters/shared";
import FilterCheckbox from "./FilterCheckbox";

type TelehealthInputProps = {
  legend: string;
  compact?: boolean;
  filters: SearchFilters;
  setFilters: Dispatch<SetStateAction<SearchFilters>>;
};

function TelehealthInput({
  legend,
  compact = false,
  filters,
  setFilters,
}: TelehealthInputProps) {
  const { t } = useTranslation();

  // eslint-disable-next-line unused-imports/no-unused-vars
  const [telehealthOptions, setTelehealthOptions] = useState(() => getLookupOptions("telehealth"));

  const setTelehealthFilter = (telehealth: optionWithId) => {
    logEvent(AnalyticsAction.UpdateFilter, {
      label: "telehealth",
      filter_type: "telehealth",
      filter_value: telehealth.translate,
    });
    
    setFilters({
      ...filters,
      telehealthOptions: toggleItemInFilterList(
        filters.telehealthOptions ?? [], 
        telehealth.lineageText
      ) as []
    });
  };

  return (
    <Fieldset legend={legend} legendStyle={compact ? "srOnly" : "large"}>
        {telehealthOptions.map((option) => (
          <FilterCheckbox
            name={option.translate}
            value={option.lineageText}
            label={t(`${option.translate}`)}
            selectedFilterValues={filters.telehealthOptions ?? []}
            onChange={() => setTelehealthFilter(option)}
            key={option.translate}
          />
        ))}
     </Fieldset>
  );
}

export default TelehealthInput;
